<template>
  <v-layout>
    <v-dialog :modelValue="dialog" @click:outside="$emit('updateDialog', false)" @keydown.esc="$emit('updateDialog', false)" max-width="1250px" transition="dialog-bottom-transition">
      <v-card>
        <v-form @submit.prevent ref="form" v-model="valid">
          <v-card-title>
            <span class="headline">{{ modal_title }}</span>
          </v-card-title>
          <v-card class="mb-4 ms-4 me-4">
            <div class="row mb-2 ps-3 pe-3 mt-0 mb-2">
              <div class="col-md-12">
                <div class="row mt-4">
                  <div class="col-md-3">
                    <v-combobox
                      v-model="filters.almacen"
                      density="comfortable"
                      name="almacen"
                      item-title="name"
                      item-value="id"
                      :items="almacenes"
                      label="Almacen"
                      autocomplete="off"
                      :disabled="disabled"
                      clearable
                      @update:modelValue="
                        () => {
                          this.loadZonas();
                          this.filters.zona = null;
                        }
                      "
                    ></v-combobox>
                  </div>
                  <div class="col-md-3">
                    <v-combobox
                      v-model="filters.zona"
                      density="comfortable"
                      item-title="name"
                      item-value="id"
                      :items="zonas"
                      label="Zona"
                      autocomplete="off"
                      clearable
                      :loading="loading_zonas"
                      @update:modelValue="
                        () => {
                          this.loadUbicaciones();
                          this.filters.ubicacion = null;
                        }
                      "
                    ></v-combobox>
                  </div>
                  <div class="col-md-3">
                    <v-combobox
                      v-model="filters.ubicacion"
                      density="comfortable"
                      :loading="loading_ubicaciones"
                      item-title="code"
                      item-value="id"
                      :items="ubicaciones"
                      label="Ubicacion"
                      autocomplete="off"
                      clearable
                    ></v-combobox>
                  </div>
                  <div class="col-md-3">
                    <v-text-field v-model="filters.lpn_code" density="comfortable" label="Codigo de LPN"></v-text-field>
                  </div>
                  <div class="col-md-3">
                    <v-combobox
                      v-model="filters.product"
                      density="comfortable"
                      name="product"
                      item-title="label"
                      item-value="id"
                      :items="products_minify"
                      label="Producto"
                      autocomplete="off"
                      :loading="loading_products"
                      clearable
                    ></v-combobox>
                  </div>

                  <div :class="'col-md-9 pt-2'" style="display: flex; justify-content: end">
                    <v-btn color="info" class="mb-3" @click="filter" prepend-icon="mdi-magnify">Buscar</v-btn>
                  </div>
                </div>
              </div>
            </div>
          </v-card>
          <v-card-text>
            <!-- START FORM DIALOG -->
            <div class="row">
              <div class="col-md-12">
                <v-btn size="small" color="blue-grey" prepend-icon="$plus" class="pl-4 text-white" @click="newAjuste">
                  <span>Agregar un producto</span>
                </v-btn>
              </div>
              <div class="col-md-12">
                <v-data-table :headers="headers" :items="list_assigned_locations" :search="search" :loading="loading_assigned_locations" loading-text="Cargando...">
                  <template v-slot:item="{ item }">
                    <tr>
                      <td>{{ item.lpn.code }}</td>
                      <td>
                        <div class="nowrap">{{ item.ubicacion.code }}</div>
                        <span class="text-caption text-grey-600">{{ item.ubicacion.zona.name }} - {{ item.ubicacion.zona.almacen.code }}</span>
                      </td>
                      <td>
                        <div>
                          <div class="text-body-2">{{ item.presentation_atributes.product_presentation.product.name }}</div>
                          <span class="text-caption text-grey-600 d-block">SKU: {{ item.presentation_atributes.product_presentation.product.sku }}</span>
                        </div>
                      </td>
                      <td>
                        {{ item.presentation_atributes.product_presentation.product.client.name }}
                      </td>
                      <td>
                        <div
                          v-if="
                            item.presentation_atributes.expiration_date ||
                            item.presentation_atributes.lote ||
                            item.presentation_atributes.serie ||
                            item.presentation_atributes.storage_units_amount ||
                            (item.presentation_atributes.quality && item.presentation_atributes.quality.name) ||
                            (isAliasEnabled('descriptivo_1') && item.presentation_atributes.descriptivo_1) ||
                            (isAliasEnabled('descriptivo_2') && item.presentation_atributes.descriptivo_2) ||
                            (isAliasEnabled('descriptivo_3') && item.presentation_atributes.descriptivo_3)
                          "
                        >
                          <div v-if="item.presentation_atributes.expiration_date" class="attribute-row">
                            <span class="attribute-label">Vencimiento:</span>
                            <span class="attribute-value">{{ item.presentation_atributes.expiration_date }}</span>
                          </div>
                          <div v-if="item.presentation_atributes.lote" class="attribute-row">
                            <span class="attribute-label">Lote:</span>
                            <span class="attribute-value">{{ item.presentation_atributes.lote }}</span>
                          </div>
                          <div v-if="item.presentation_atributes.serie" class="attribute-row">
                            <span class="attribute-label">Serie:</span>
                            <span class="attribute-value">{{ item.presentation_atributes.serie }}</span>
                          </div>
                          <div v-if="item.presentation_atributes.storage_units_amount" class="attribute-row">
                            <span class="attribute-label">Almacenamiento:</span>
                            <span class="attribute-value">{{ item.presentation_atributes.storage_units_amount }}</span>
                          </div>
                          <div v-if="item.presentation_atributes.quality && item.presentation_atributes.quality.name" class="attribute-row">
                            <span class="attribute-label">Calidad:</span>
                            <span class="attribute-value">
                              <v-chip size="x-small" color="primary">{{ item.presentation_atributes.quality.name }}</v-chip>
                            </span>
                          </div>
                          <div v-if="isAliasEnabled('descriptivo_1') && item.presentation_atributes.descriptivo_1" class="attribute-row">
                            <span class="attribute-label">{{ getAliasName("descriptivo_1") }}:</span>
                            <span class="attribute-value">{{ item.presentation_atributes.descriptivo_1 }}</span>
                          </div>
                          <div v-if="isAliasEnabled('descriptivo_2') && item.presentation_atributes.descriptivo_2" class="attribute-row">
                            <span class="attribute-label">{{ getAliasName("descriptivo_2") }}:</span>
                            <span class="attribute-value">{{ item.presentation_atributes.descriptivo_2 }}</span>
                          </div>
                          <div v-if="isAliasEnabled('descriptivo_3') && item.presentation_atributes.descriptivo_3" class="attribute-row">
                            <span class="attribute-label">{{ getAliasName("descriptivo_3") }}:</span>
                            <span class="attribute-value">{{ item.presentation_atributes.descriptivo_3 }}</span>
                          </div>
                        </div>
                        <span v-else>-</span>
                      </td>
                      <td class="text-center">
                        <div class="quantity-display">
                          <span class="quantity-value">{{ item.available_stock }}</span>
                        </div>
                      </td>
                      <td class="text-center">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ props }">
                            <!-- v-if="update_access" -->
                            <v-icon v-bind="props" small color="blue" class="mr-2" v-on:click="editAjuste(item)" size="small"> mdi-pencil</v-icon>
                          </template>
                          <span>Editar</span>
                        </v-tooltip>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </div>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="close">Cerrar</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
      <ModalAjuste :dialog="dialog_assigned_location" :itemEdit="itemEdit" @updateDialog="dialog_assigned_location = false" :service="service" @loadAssignedLocations="loadAssignedLocations" />
    </v-dialog>
  </v-layout>
</template>

<script>
import { almacenService } from "@/libs/ws/almacenService";
import { zonaService } from "@/libs/ws/zonaService";
import { productoService } from "@/libs/ws/productoService";
import ValidMixin from "@/mixins/ValidMixin.vue";
import ModalAjuste from "./ModalAjuste";
import AliasMixin from "@/mixins/AliasMixin.vue";

export default {
  components: { ModalAjuste },
  mixins: [ValidMixin, AliasMixin],
  props: {
    service: Object,
    button_name: String,
    modal_title: String,
    page_title: String,
    formBtn: String,
    dialog: Boolean,
    updateDialog: Function,
    loadList: Function,
  },
  data() {
    return {
      show: false,
      disabled: false,
      loading_assigned_locations: false,
      list_assigned_locations: [],
      dialog_assigned_location: false,
      roles: [],
      almacenes: [],
      zonas: [],
      ubicaciones: [],
      loading_ubicaciones: false,
      loading_zonas: false,
      products_minify: [],
      loading_products: false,
      name: "",
      headers: [],
      filters: {
        almacen: null,
        zona: null,
        ubicacion: null,
        product: null,
        lpn_code: null,
      },
      defaultItem: null,
      itemEdit: null,
      itemEditIndex: null,
    };
  },
  watch: {
    dialog() {
      if (this.dialog) {
        this.disabled = this.formBtn == "";

        if (this.$refs.form) {
          this.$refs.form.resetValidation();
        }
      }
    },
  },
  mounted() {
    this.loadAlmacenes();
    this.loadProductsMinify();
    this.loadAliasMap().then(() => {
      this.setupHeaders(); // Se llama luego para que exista el mapa de alias
    });
  },
  methods: {
    setupHeaders() {
      this.headers = [
        {
          title: "LPN",
          align: "left",
          sortable: true,
          key: "lpn.code",
        },
        {
          title: "Ubicación",
          align: "left",
          sortable: true,
          key: "ubicacion.code",
        },
        {
          title: "Producto",
          align: "left",
          sortable: true,
          key: "presentation_atributes.product_presentation.product.name",
        },
        {
          title: "Cliente",
          align: "left",
          sortable: true,
          key: "presentation_atributes.product_presentation.product.client.name",
        },
        {
          title: "Atributos",
          align: "left",
          sortable: false,
          key: "attributes",
        },
        {
          title: "Cantidad",
          align: "center",
          sortable: true,
          key: "available_stock",
        },
        { title: "Accion", align: "center", sortable: false, key: "" },
      ];
    },
    close() {
      this.$emit("updateDialog", false);
      this.list_assigned_locations = [];
      this.filters = {
        almacen: null,
        zona: null,
        ubicacion: null,
        product: null,
        lpn_code: null,
      };
      this.$emit("loadList");
    },
    newAjuste() {
      this.itemEdit = null;
      this.itemEditIndex = null;
      this.dialog_assigned_location = true;
    },
    editAjuste(item) {
      this.itemEditIndex = this.list_assigned_locations.indexOf(item);
      this.itemEdit = Object.assign({}, item);
      this.dialog_assigned_location = true;
    },
    getFilterParams() {
      return this.filters;
    },
    loadAssignedLocations() {
      this.loading_assigned_locations = true;

      const param = {
        enable: true,
      };

      //agrego los parametros a param
      Object.assign(param, this.getFilterParams());

      this.open_filter = false;
      this.service
        .list_assigned_locations(param)
        .then((response) => {
          if (response.status) {
            this.list_assigned_locations = response.result.list;
          }
        })
        .catch((e) => {
          console.log("service.filter error");
          console.log(e);
        })
        .finally(() => {
          this.loading_assigned_locations = false;
        });
    },
    filter() {
      this.loadAssignedLocations();
    },
    loadAlmacenes() {
      almacenService
        .filter({})
        .then((response) => {
          this.almacenes = response.result.list;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        });
    },
    loadZonas() {
      this.loading_zonas = true;
      const params = {
        almacen: this.filters.almacen,
      };

      zonaService
        .filter(params)
        .then((response) => {
          if (response.status === true) {
            this.zonas = response.result.list;
          } else {
            this.zonas = [];
            this.toast.error(response.msg);
          }
        })
        .finally(() => {
          this.loading_zonas = false;
        });
    },
    loadUbicaciones() {
      this.loading_ubicaciones = true;
      zonaService
        .get_ubicaciones({
          zona: this.filters.zona,
        })
        .then((response) => {
          this.ubicaciones = response.result;
        })
        .finally(() => {
          this.loading_ubicaciones = false;
        });
    },
    loadProductsMinify() {
      this.loading_products = true;
      productoService
        .list_minify()
        .then((response) => {
          this.products_minify = response.result.list;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        })
        .finally(() => {
          this.loading_products = false;
        });
    },
  },
};
</script>
